<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">
              {{ $t("subcourses.createNewSubcourse") }}
            </p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.title"
                  :placeholder="$t('subcourses.subcourseTitle')"
                  :isRequired="true"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.price"
                  :placeholder="$t('subcourses.coursePrice')"
                  type="number"
                  :isRequired="true"
                  @select-change="handleFirstSelectChange"
                />
              </div>

              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.numberOfMonths"
                  :placeholder="$t('subcourses.numberOfMonths')"
                  type="text"
                  :isRequired="true"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <SelectFormCourse
                  @select="getCourse"
                  v-model="courses"
                  :selectedOption="$t('courses.selectCourse')"
                  :isRequired="true"
                />
              </div>
              <div class="mb-3">
                <DatePicker
                  v-model="formData.start_date"
                  :placeholder="$t('subcourses.startFrom')"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.create") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SoftButton,
    SoftBadge,
    DatePicker,
  },
  data() {
    return {
      formData: {
        title: "",
        course_id: null,
        price: "",
        numberOfMonths: "",
        start_date: "",
      },
      courses: [],
      subcourses: [],
      selectedFile: null,
      selectedCourse: null,
      selectedSubcourse: null,
      isFirstSelected: false,
      imageUrl: "",
    };
  },
  computed() {
    //return this.test();
  },
  created() {
    this.getCourses();
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      try {
        await axios.post("subcourse", {
          title: this.formData.title,
          course_id: this.formData.course_id,
          price: this.formData.price,
          numberOfMonths: this.formData.numberOfMonths,
          start_date: this.formData.start_date,
        });
        this.resetForm();
        this.$emit("fetch-subcourses");
        this.$emit("close");
        swal.fire({
          icon: "success",
          title: this.$t("subcourses.subcourseCreated"),
          showConfirmButton: false,
          timer: 2000,
        });
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    async getCourses() {
      const response = await axios.get("courses/all");
      this.courses = response.data.courses;
    },
    getCourse(selectedCourse) {
      this.formData.course_id = selectedCourse;
    },
    setCourse(selectedCource) {
      this.formData.course = selectedCource;
    },
    handleFirstSelectChange(selectedValue) {
      this.isFirstSelected = !!selectedValue;
    },
    resetForm() {
      this.formData.title = "";
      this.formData.course = null;
      this.formData.price = "";
      this.formData.start_date = "";
      this.formData.numberOfMonths = "";

      return;
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}
#file {
  display: none;
}
.custom-file-upload span {
  pointer-events: none;
}
.float-right {
  float: right;
}
</style>
